import isControllerEmpty from './is-controller-empty';

const isOwnerEmpty = (owner) => {
  if (owner) {
    const share = parseInt(owner.share, 10);
    return (isNaN(share) || !share) || isControllerEmpty(owner);
  }
  return true;
};

export default isOwnerEmpty;

